import { toSimpleAddressFormat } from "@/utils/util";
import { MenuItem } from "@biom3/react";

type EOAWalletDisconnectProps = {
  walletAddress: string;
  disconnect: () => Promise<void>;
};

export const EOAWalletDisconnect = ({
  walletAddress,
  disconnect,
}: EOAWalletDisconnectProps) => {
  return (
    <MenuItem
      size="xSmall"
      emphasized
      sx={{
        minHeight: "base.spacing.x10",
        minWidth: "260px",
      }}
    >
      <MenuItem.Icon icon="Wallet" />
      <MenuItem.Label size="xxSmall">
        {toSimpleAddressFormat(walletAddress)}
      </MenuItem.Label>
      <MenuItem.Button onClick={disconnect}>Disconnect</MenuItem.Button>
    </MenuItem>
  );
};
